import { rateGuarantee } from "./sharedTypedAmount";

import type { TypedAmountTypeOption } from "../typedAmountTypes";

const SENTINEL_OPTIONS: TypedAmountTypeOption[] = [
  { value: "notDisclosed", label: "Not Disclosed", hideAmount: true },
  { value: "notIncluded", label: "Not Included", hideAmount: true },
  { value: "notOffered", label: "Not Offered", hideAmount: true },
];

const DOLLAR_AMOUNT_OPTIONS: TypedAmountTypeOption[] = [
  { value: "dollarAmount", label: "Dollar amount" },
  ...SENTINEL_OPTIONS,
];

const WELLNESS_OPTIONS: TypedAmountTypeOption[] = [
  { value: "dollarAmount", label: "Dollar amount" },
  { value: "notIncluded", label: "Not Included", hideAmount: true },
  { value: "notOffered", label: "Not Offered", hideAmount: true },
];

export interface HospitalTypedAmountSpec {
  typeKey: string;
  amountKey: string;
  amountLabel: string;
  typeOptions: TypedAmountTypeOption[];
  amountMin?: number;
  amountInteger?: boolean;
}

export const hospitalTypedAmountFields: Record<
  string,
  HospitalTypedAmountSpec
> = {
  hospitalAdmission: {
    typeKey: "hospitalAdmissionType",
    amountKey: "hospitalAdmissionAmount",
    amountLabel: "Amount",
    typeOptions: DOLLAR_AMOUNT_OPTIONS,
  },
  icuAdmission: {
    typeKey: "icuAdmissionType",
    amountKey: "icuAdmissionAmount",
    amountLabel: "Amount",
    typeOptions: DOLLAR_AMOUNT_OPTIONS,
  },
  hospitalConfinement: {
    typeKey: "hospitalConfinementType",
    amountKey: "hospitalConfinementAmount",
    amountLabel: "Amount",
    typeOptions: DOLLAR_AMOUNT_OPTIONS,
  },
  icuConfinement: {
    typeKey: "icuConfinementType",
    amountKey: "icuConfinementAmount",
    amountLabel: "Amount",
    typeOptions: DOLLAR_AMOUNT_OPTIONS,
  },
  wellness: {
    typeKey: "wellnessType",
    amountKey: "wellnessAmount",
    amountLabel: "Amount",
    typeOptions: WELLNESS_OPTIONS,
  },
  rateGuarantee,
};
